import { gql } from '~/src/redesign/shared/graphql';

export const BASIC_PROFILE = gql(`
  query basicProfile {
    me {
      id
      firstName
      lastName
      dateJoined
      vetProfile {
        id
        verifiedInfo
        askForNetPromoterScore
        licenses {
          id
          expirationDate
          number
          stateCode
        }
      }
    }
  }
`);
